import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExamRoutingModule } from './exam-routing.module'
import { AuthService } from 'src/app/core/services/auth.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TestComponent } from './test/test.component';
import { ExamComponent } from './exam/exam.component';
import { HttpInterceptorProviders } from 'src/app/core/interceptors';
import { RouteStateService } from 'src/app/core/services/route-state.service';
import { BootstrapModule } from 'src/app/shared/shared-bootstrap.module';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { BrowserModule } from '@angular/platform-browser';
import { SharedPipesModule } from 'src/app/shared/shared-pipes.module';



@NgModule({
  declarations: [
    TestComponent,
    ExamComponent
  ],
  imports: [
    CommonModule,
    ExamRoutingModule,
    DigitOnlyModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HttpClientJsonpModule,
    ReactiveFormsModule,
    BootstrapModule,
    SharedPipesModule
  ],
  providers: [
    RouteStateService,
    AuthService,
    HttpInterceptorProviders,

  ],
})
export class ExamModule { }
